'use strict';

export default function f(modal) {
  'ngInject';

  return {
    open: function () {

      return modal.open({
        template: '<sa-trip-offer-accept-modal done="close()"></sa-trip-offer-accept-modal>'
      }).result;
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/components/conversations/trip_offer_accept_modal/trip_offer_accept_modal.service.js